import { SocketUpdates } from '../typings/socket-updates';
import { get } from '../../infra/rest';

export const getSocketUpdates = async (lastUpdateTimestamp: number) => {
  return get<SocketUpdates>(
    `/v5/updates?lastUpdateTimestamp=${lastUpdateTimestamp}&getMultiselectCustomFields=true`,
    {},
    true
  );
};

export default getSocketUpdates;
